module.exports = __webpack_public_path__ + "img/mainback.24ecf2aa.png";